// 
import WebComponent from '../webComponents/WebComponent';
import { isTouchDevice } from '../../plugins/utils';

/**
 *  EshopVariantStockHandler | eshop - detail produktu - komponenta productDetailVariantForm
 *  -  pokud uzivatel vybral N-1 variantnich parametru (kde N je celkovy pocet typu variantnich parametru), zobrazi se mu u zbyvajiciho parametru skladovou dostupnost cilovych variant
 *  - data-show-on-label: zobrazi skladovou dostupnost v labelu prislusneho parametru po najeti mysi nad parametr, funguje pouze pro input radio  (default: true)
 *  - data-show-on-input: zobrazi skladovou dostupnost v ramci prislusneho inputu (default: true)
 */
class EshopVariantStockHandler extends WebComponent {
  constructor(props) {
    super(props);
    this.enableMouseOver = this.enableMouseOver.bind(this);
    this.enableRenderOnInput = this.enableRenderOnInput.bind(this);
    this.enableReplaceImage = this.enableReplaceImage.bind(this);
  }
	didMount() {
    const {
      showOnLabel,
      showOnInput,
      replaceImage,
    } = this.props;

    this.formGroups = this.element.querySelectorAll('.form-group');

    // pamatování stavu scrollTop při přechodu mezi stránkami
    this.enableScrollTopHandler();

    // zobrazeni dostupnosti pri mouseoveru
    if (showOnLabel && !isTouchDevice()) {
      this.enableMouseOver();
    }

    // zobrazeni dostupnosti v ramci prislusneho inputu
    if (showOnInput) {
      this.enableRenderOnInput();
    }

    // pri kliknuti nahradit obrazek v galerii za dodany
    if (replaceImage) {
      this.enableReplaceImage();
    }
	}

	enableScrollTopHandler() {
    this.getScrollTop();
    document.addEventListener('beforeFullPageRedirect', (event) => {
      this.saveScrollTop();
    });

    const links = document.querySelectorAll('a[data-turbolinks-save-scroll=true]');

    Array.from(links).forEach(link => {
      link.addEventListener('click', () => {
        this.saveScrollTop();
      });
    });
  }

  saveScrollTop() {
    const {
      storageTTL,
    } = this.props;

    if (window.localStorage) {
      const now = new Date();
      const item = {
        value: document.scrollingElement.scrollTop,
        expiry: now.getTime() + storageTTL,
      }
      localStorage.setItem('pageScrollTop', JSON.stringify(item));
    }
  }

  getScrollTop() {
    const {
      storageTTL,
    } = this.props;

    if (window.localStorage) {
      const scrollTopData = localStorage.getItem('pageScrollTop');

      if (scrollTopData) {
        const item = JSON.parse(scrollTopData)
        const now = new Date()

        if (now.getTime() > item.expiry) {
          localStorage.removeItem('pageScrollTop');
        }
        else {
          document.scrollingElement.scrollTop = item.value;
        }
      }
    }
  }

	enableMouseOver() {
    const {
      onStockClass,
      notOnStockClass,
      showPriceCompare,
    } = this.props;

    Array.from(this.formGroups).forEach(formGroup => {

      const formControls = formGroup.querySelectorAll('.form-group__control');

      // na select option neexistuje mouseover eventa, v pripade selectu neni podpora mozna

      Array.from(formControls).forEach(formControl => {
        if (formControl.nodeName == "INPUT") {
          const parentElement = formControl.parentElement;
          const formLabel = parentElement.querySelector('label');
          const formLabelCaption = formLabel.innerText;
          const formGroupLabel = formGroup.querySelector('.form-group__label');
          const formGroupLabelValue = formGroup.querySelector('.form-group__label-value');
          const formGroupLabelCaption = formGroupLabel.innerHTML;
          const onStock = formControl.getAttribute('data-on-stock');
          const availability = formControl.getAttribute('data-availability');
          const price = formControl.getAttribute('data-price');
          let stockInfo = '';
          let priceInfo = '';
          let formGroupLabelValueCaption;

          if (formGroupLabelValue) {
            formGroupLabelValueCaption = formGroupLabelValue.innerHTML;
          }

          if (onStock == "true") {
            stockInfo = `, <span class="${onStockClass}">${availability}</span>`;
          }
          else if (onStock == "false") {
            stockInfo = `, <span class="${notOnStockClass}">${availability}</span>`;
          }

         if (price && showPriceCompare) {
           priceInfo = `, ${price}`;
         }

          parentElement.addEventListener('mouseover', () => {
            if (formGroupLabelValue) {
              formGroupLabelValue.innerHTML = `${formLabelCaption}${stockInfo}${priceInfo}`;
            }
            else {
              formGroupLabel.innerHTML = `${formGroupLabelCaption}: <span class="form-group__label-value">${formLabelCaption}${stockInfo}${priceInfo}</span>`;
            }
          });
          parentElement.addEventListener('mouseout', () => {
            if (formGroupLabelValue) {
              formGroupLabelValue.innerHTML = formGroupLabelValueCaption;
            }
            else {
              formGroupLabel.innerHTML = formGroupLabelCaption;
            }
          });
        }
      });
    });
  }

  enableRenderOnInput() {
    const {
      onStockClass,
      notOnStockClass,
    } = this.props;

    Array.from(this.formGroups).forEach(formGroup => {

      const formControls = formGroup.querySelectorAll('.form-group__control');
      Array.from(formControls).forEach(formControl => {

        // select
        if (formControl.nodeName == "SELECT") {
          const formControlOptions = formControl.querySelectorAll('option');
          Array.from(formControlOptions).forEach(formControlOption => {
            const onStock = formControlOption.getAttribute('data-on-stock');
            const availability = formControlOption.getAttribute('data-availability');

            if (onStock == 'true') {
              formControlOption.classList.add(onStockClass);
              formControlOption.innerHTML = `${formControlOption.innerHTML}  (${availability})`;
            } else if (onStock == 'false') {
              formControlOption.classList.add(notOnStockClass);
            }
          });
        // input radio
        } else if (formControl.nodeName == "INPUT") {
            const onStock = formControl.getAttribute('data-on-stock');

            if (onStock == 'true') {
              formControl.classList.add(onStockClass);
            } else if (onStock == 'false') {
              formControl.classList.add(notOnStockClass);
            }
        }
      });

    });
  }

  enableReplaceImage() {
    const {
      galleryImageSelector,
      galleryImageLinkSelectorAll,
      galleryImageThumbSelector,
      galleryImageThumbLinkSelector,
      galleryImageThumbLinkSelectorAll,
    } = this.props;

    Array.from(this.formGroups).forEach(formGroup => {
      const formControls = formGroup.querySelectorAll('.form-group__control');

      Array.from(formControls).forEach(formControl => {
        formControl.addEventListener('click', (event) => {
          const imageSource = formControl.getAttribute('data-replace-image-source');
          const imageSourceX2 = formControl.getAttribute('data-replace-image-source-x2');
          const imageSourceWebp = formControl.getAttribute('data-replace-image-source-webp');
          const imageSourceX2Webp = formControl.getAttribute('data-replace-image-source-x2-webp');

          const imageSourceThumb = formControl.getAttribute('data-replace-image-source-thumb');
          const imageSourceThumbX2 = formControl.getAttribute('data-replace-image-source-thumb-x2');
          const imageSourceThumbWebp = formControl.getAttribute('data-replace-image-source-thumb-webp');
          const imageSourceThumbX2Webp = formControl.getAttribute('data-replace-image-source-thumb-x2-webp');

          const imageSourceFull = formControl.getAttribute('data-replace-image-source-full');
          const imageSourceFullX2 = formControl.getAttribute('data-replace-image-source-full-x2');
          const imageSourceFullWebp = formControl.getAttribute('data-replace-image-source-full-webp');
          const imageSourceFullX2Webp = formControl.getAttribute('data-replace-image-source-full-x2-webp');

          // replace main image
          this.replaceImage(imageSource,galleryImageSelector,'src');
          this.replaceImage(imageSourceFull,galleryImageSelector,'data-magnify-src');
          if (imageSourceX2) {
            this.replaceSrcSet(`${imageSource} 1x, ${imageSourceX2} 2x`, galleryImageSelector, false);
          }
          if (imageSourceWebp && !imageSourceX2Webp) {
            this.replaceSrcSet(imageSourceWebp, galleryImageSelector, true);
          }
          if (imageSourceWebp && imageSourceX2Webp) {
            this.replaceSrcSet(`${imageSourceWebp} 1x, ${imageSourceX2Webp} 2x`, galleryImageSelector, true);
          }

          // replace thumb image
          this.replaceImage(imageSourceThumb,galleryImageThumbSelector,'src');
          if (imageSourceThumbX2) {
            this.replaceSrcSet(`${imageSourceThumb} 1x, ${imageSourceThumbX2} 2x`, galleryImageThumbSelector, false);
          }
          if (imageSourceThumbWebp && !imageSourceThumbX2Webp) {
            this.replaceSrcSet(imageSourceThumbWebp, galleryImageThumbSelector, true);
          }
          if (imageSourceThumbWebp && imageSourceThumbX2Webp) {
            this.replaceSrcSet(`${imageSourceThumbWebp} 1x, ${imageSourceThumbX2Webp} 2x`, galleryImageThumbSelector, true);
          }

          // replace href
          this.replaceImage(imageSource,galleryImageThumbLinkSelector,'href');
          this.replaceImage(imageSourceX2,galleryImageThumbLinkSelector,'data-href-x2');
          this.replaceImage(imageSourceWebp,galleryImageThumbLinkSelector,'data-href-webp');
          this.replaceImage(imageSourceX2Webp,galleryImageThumbLinkSelector,'data-href-x2-webp');

          // replace data-zoom
          this.replaceImage(imageSourceFull,galleryImageThumbLinkSelector,'data-zoom');

          // set for PU popup gallery
          this.replaceImage(imageSourceThumb,galleryImageLinkSelectorAll,'data-replace-image-source-thumb');
          this.replaceImage(imageSourceThumbX2,galleryImageLinkSelectorAll,'data-replace-image-source-thumb-x2');
          this.replaceImage(imageSourceThumbWebp,galleryImageLinkSelectorAll,'data-replace-image-source-thumb-webp');
          this.replaceImage(imageSourceThumbX2Webp,galleryImageLinkSelectorAll,'data-replace-image-source-thumb-x2-webp');

          this.replaceImage(imageSourceThumb,galleryImageThumbLinkSelectorAll,'data-replace-image-source-thumb');
          this.replaceImage(imageSourceThumbX2,galleryImageThumbLinkSelectorAll,'data-replace-image-source-thumb-x2');
          this.replaceImage(imageSourceThumbWebp,galleryImageThumbLinkSelectorAll,'data-replace-image-source-thumb-webp');
          this.replaceImage(imageSourceThumbX2Webp,galleryImageThumbLinkSelectorAll,'data-replace-image-source-thumb-x2-webp');

          this.replaceImage(imageSourceFull,galleryImageLinkSelectorAll,'data-replace-image-source-full');
          this.replaceImage(imageSourceFullX2,galleryImageLinkSelectorAll,'data-replace-image-source-full-x2');
          this.replaceImage(imageSourceFullWebp,galleryImageLinkSelectorAll,'data-replace-image-source-full-webp');
          this.replaceImage(imageSourceFullX2Webp,galleryImageLinkSelectorAll,'data-replace-image-source-full-x2-webp');

          this.replaceImage(imageSourceFull,galleryImageThumbLinkSelectorAll,'data-replace-image-source-full');
          this.replaceImage(imageSourceFullX2,galleryImageThumbLinkSelectorAll,'data-replace-image-source-full-x2');
          this.replaceImage(imageSourceFullWebp,galleryImageThumbLinkSelectorAll,'data-replace-image-source-full-webp');
          this.replaceImage(imageSourceFullX2Webp,galleryImageThumbLinkSelectorAll,'data-replace-image-source-full-x2-webp');
        });
      });
    });
  }

  replaceSrcSet(data,targetSelector, webpType) {
    const target = document.querySelector(targetSelector);
    let selector = 'source[type="image/webp"]';

    if (data && target) {
      if (!webpType) {
        selector = 'source:last-of-type';
      }
      const targetSource = target.parentElement.querySelector(selector);
      targetSource.setAttribute('srcset',data);
    }
  }

  replaceImage(data, targetSelector, attribute) {
    const targets = document.querySelectorAll(targetSelector);

    if (data && targets.length > 0 && attribute) {
      targets.forEach((target) => {
        target.setAttribute(attribute, data);
      });
    }
  }
}


EshopVariantStockHandler.defaultProps = {
  onStockClass: 'stock-info--available',
  notOnStockClass: 'stock-info--unavailable',
  galleryImageSelector: '.eshop-gallery__item:first-child .eshop-gallery__img',
  galleryImageLinkSelectorAll: '.eshop-gallery__item .eshop-gallery__link',
  galleryImageThumbSelector: '.eshop-gallery__thumblist-item:first-child .eshop-gallery__thumblist-img',
  galleryImageThumbLinkSelector: '.eshop-gallery__thumblist-item:first-child .eshop-gallery__thumblist-link',
  galleryImageThumbLinkSelectorAll: '.eshop-gallery__thumblist-item .eshop-gallery__thumblist-link',
  storageTTL: 5000,
}


export default EshopVariantStockHandler;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/EshopVariantStockHandler.js